







































import { Component, Mixins } from 'vue-property-decorator'
import { ItunesTrack } from '@/classes/itunes'
import { subWeeks, isAfter } from 'date-fns'
import { trackListContainsItunesTrack } from '@/helpers/features/musiccharts'
import { LibraryMixin } from '@/mixins'
import { Track } from '@/classes/track'
import { ITUNES_GENRES } from '@/helpers/itunes'
import { toDateStringSafe } from '@/helpers/date'
import { IStoreLink, STORE_LINK_SOURCES } from '@/store/modules/storelinks'
import * as _ from 'lodash'

const WEEK_AMOUNT_ISNEW = 4

interface IITunesTrackObject {
  rank: number
  isNew: boolean
  isOwned: boolean
  track: ItunesTrack
  libraryTrack: Track
}

@Component({
  components: {
    MusicChartsTrack: require('./MusicChartsTrack').default,
    PlaylistSaveModal: require('@/components/PlaylistSaveModal').default,
    GlobalWaveformPlayer: require('@/components/GlobalWaveformPlayer').default
  }
})
export default class MusicChartsTrackList extends Mixins(LibraryMixin) {
  showOwned: boolean = true
  showOnlyNew: boolean = false

  foundItunesTrackIds: { [key: number]: boolean } = {}

  get suggestedPlaylistName(): string {
    const genreLabel = ITUNES_GENRES.find(x => x.id === this.$store.state.musiccharts.lastGenreId)

    let s: string = `Music Charts:`

    if (genreLabel) s += ` ${genreLabel.label}`

    s += ` (${this.$store.state.musiccharts.lastCountryCode}) ${toDateStringSafe(new Date())}`

    return s
  }

  get ownedItunesTrackIds(): number[] {
    return this.$store.state.musiccharts.itunesTrackIdsMarkedOwned
  }

  get notOwnedItunesTrackIds(): number[] {
    return this.$store.state.musiccharts.itunesTrackIdsMarkedNotOwned
  }

  get trackItems(): IITunesTrackObject[] {
    let now = new Date()

    if (this.$store.state.auth.isDemoUser) {
      now = new Date('2019-07-20')
    }

    const trackObjects: IITunesTrackObject[] = this.$store.state.musiccharts.tracks.map((t: ItunesTrack, index: number) => {
      return {
        rank: index + 1,
        isOwned: false, // Do this in next getter so that this getter isnt triggered
        libraryTrack: null,
        isNew: isAfter(new Date(t.itunesReleaseDate), subWeeks(now, WEEK_AMOUNT_ISNEW)),
        track: t
      }
    })

    return trackObjects
  }

  get ownedTracksInLibrary(): Track[] {
    return this.trackItemsWithOwnedProp.filter(x => x.isOwned && x.libraryTrack).map(x => x.libraryTrack)
  }

  get trackItemsWithOwnedProp(): IITunesTrackObject[] {
    return this.trackItems.map(t => {
      const isOwnedResult = this.isOwned(t.track)

      t.isOwned = isOwnedResult.owned

      if (isOwnedResult.track) {
        t.libraryTrack = isOwnedResult.track
      }

      return t
    })
  }

  get trackItemsFiltered(): IITunesTrackObject[] {
    return this.trackItemsWithOwnedProp.filter((t: IITunesTrackObject) => {
      if (this.showOnlyNew && !t.isNew) return false // Filter old tracks
      if (this.showOnlyNew && t.isOwned) return false // Filter owned tracks if showing only new
      if (!this.showOwned) return !t.isOwned // Filter owned tracks if checkbox off

      return true
    })
  }

  async pipeToStoreLinks() {
    const unownedTracks = this.trackItemsWithOwnedProp.filter(x => !x.isOwned)

    let cachedLinks: IStoreLink[] = []

    for (const track of unownedTracks) {
      const trackPageUrl = new URL(track.track.viewUrl as string)

      trackPageUrl.searchParams.append('at', '1001l32Qi')

      cachedLinks.push({
        _id: '',
        artist: track.track.artistName,
        title: track.track.title,
        pages: {
          itunes: `https://music.apple.com/us/search?term=${encodeURIComponent(`${track.track.artistName} ${track.track.title}`)}&at=1001l32Qi`
        },
        links: [
          {
            source: STORE_LINK_SOURCES.AppleMusic,
            artist: track.track.artistName,
            title: track.track.title,
            url: trackPageUrl.toString(),
            releaseDate: new Date(track.track.itunesReleaseDate)
          }
        ]
      })
    }

    cachedLinks = _.uniqBy(cachedLinks, (t) => t.artist + t.title)

    this.$store.commit('storelinks/setCached', cachedLinks)

    await this.$router.push({
      name: 'store links results'
    })
  }

  isFoundInLibrary(itunesTrack: ItunesTrack): { owned: boolean, track: Track | null } {
    if (this.foundItunesTrackIds.hasOwnProperty(itunesTrack.itunesTrackId)) {
      return {
        owned: this.foundItunesTrackIds[itunesTrack.itunesTrackId],
        track: null
      }
    }

    const track: Track | null = trackListContainsItunesTrack(this.library.tracks, itunesTrack)

    const owned: boolean = !!track

    this.foundItunesTrackIds[itunesTrack.itunesTrackId] = owned // Cache for performance

    return {
      owned,
      track
    }
  }

  isOwned(track: ItunesTrack): { owned: boolean, track: Track | null } {
    if (this.ownedItunesTrackIds.includes(track.itunesTrackId)) {
      return {
        owned: true,
        track: null
      }
    } else if (this.notOwnedItunesTrackIds.includes(track.itunesTrackId)) {
      return {
        owned: false,
        track: null
      }
    }

    const trackInLibrary = this.isFoundInLibrary(track)

    return trackInLibrary
  }
}
